/**
 * 指令 v-put-in-dialog
 * 作用：将当前dom插入dialog中
 * 用法：<div v-put-in-dialog="show" dsf-dialog-title="弹窗" dsf-dialog-width="500px" dsf-dialog-height="500px"></div>
 * 参数：dsf-dialog-title 弹窗标题，不传或传空串则隐藏标题栏
 *       dsf-dialog-full 是否全屏
 *       dsf-dialog-width 弹窗宽
 *       dsf-dialog-height 弹窗高
 *       dsf-dialog-class 自定义弹窗class
 * 注意：1、v-put-in-dialog的值不能是表达式，只能是变量，可设置该变量值来控制弹窗展开和关闭
 *       2、弹窗中dom宽高需要自己在样式中实现
 */
export default {
  install(Vue) {
    Vue.directive("putInDialog", {
      inserted(el, { value, expression }, vnode){
        const vm = vnode.context;
        value && open(el, expression, vm);
      },
      update(el, { value, expression}, vnode) {
        const vm = vnode.context;
        value ? open(el, expression, vm) : close(el, expression, vm);
      },
      unbind(el, { value, expression}, vnode) {
        const vm = vnode.context;
        close(el, expression, vm)
      },
    });
  }
}

function getDialogParams(el) {
  let title = el.getAttribute('dsf-dialog-title') || '';
  let width = el.getAttribute('dsf-dialog-width') || 'auto';
  let height = el.getAttribute('dsf-dialog-height') || 'auto';
  let fullscreen = el.getAttribute('dsf-dialog-full');
  let customClass = el.getAttribute('dsf-dialog-class') || '';
  customClass += ' browseScope';
  return {
    title,
    width,
    height,
    customClass,
    noTitle: !title,
    fullscreen: !(fullscreen === null || fullscreen === 'false' || fullscreen === '0')
  }
}

function open(el, expression, vm) {
  if (el.__vPutInDialogComment) return;
  el.__vPutInDialogComment = document.createComment('put-in-dialog');
  let opt = getDialogParams(el);
  opt.onClosed = () => {
    if (!el.__vPutInDialogComment) return;
    let parentNode = el.__vPutInDialogComment.parentNode;
    parentNode.insertBefore(el, el.__vPutInDialogComment);
    parentNode.removeChild(el.__vPutInDialogComment);
    el.__vPutInDialogComment = undefined;
    setValue(vm, expression, false);
    dsf.dispatchResize();
  };
  opt.onOpened = () => {
    el.parentNode.insertBefore(el.__vPutInDialogComment, el);
    let dom = dialog.$el.querySelector('.ds-dialog-content');
    dom.appendChild(el);
    dsf.dispatchResize();
  }
  let dialog = dsf.layer.openDialog(opt);
  el.__dialog = dialog;
}

function close(el, expression, vm) {
  if (!el.__vPutInDialogComment) return;
  let parentNode = el.__vPutInDialogComment.parentNode;
  parentNode.insertBefore(el, el.__vPutInDialogComment);
  parentNode.removeChild(el.__vPutInDialogComment);
  el.__vPutInDialogComment = undefined;
  setValue(vm, expression, false);
  el.__dialog.close();
  el.__dialog = undefined;
  dsf.dispatchResize();
}

function setValue(vm, expression, val) {
  expression = _.trim(expression);
  let fn = new Function('__vm__', '__val__', `
    with (__vm__) {
      ${expression} = __val__;
    }
  `);
  fn(vm, val);
}